import { useTranslate } from '@tolgee/react';
import { useChannel2Platform } from '../hooks/useChannel2Platform';
import { Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import StatusButton from 'components/StatusButton';
import { useState } from 'react';
import { useReviewContext } from '../Context';

interface ReplyButtonProps {
  onSubmit: (commentId?: string) => Promise<void>;
}

export const ReplyButton = (props: ReplyButtonProps) => {
  const { onSubmit } = props;
  const { t } = useTranslate();
  const { detail } = useReviewContext();
  const { channel, reviewDetails } = detail;
  const { isTikTokCommon } = useChannel2Platform()(channel);
  const [replyType, setReplyType] = useState<Review.ReplyType>('mainReply');
  const [loading, setLoading] = useState(false);

  if (isTikTokCommon) {
    // 过滤出买家评价列表(最多有两个买家评论)
    const buyerFollowReview = reviewDetails?.find((item) => item.commentType === 1);
    // 卖家回复主评
    const sellerMainReply = reviewDetails?.find(
      (item) => item.commentType === 2 && item.reviewType === 'MAIN_REPLY',
    );
    // 卖家回复追评
    const sellerFollowReply = reviewDetails?.find(
      (item) => item.commentType === 2 && item.reviewType === 'FOLLOW_REPLY',
    );

    const tiktokReply = (id?: string) => {
      setLoading(true);
      onSubmit(id).finally(() => {
        setLoading(false);
      });
    };

    if (!sellerMainReply && !sellerFollowReply && detail && buyerFollowReview) {
      // 当买家有两个评论且卖家未回复过，则有两种回复选择
      return (
        <Dropdown.Button
          trigger={['click']}
          icon={<DownOutlined />}
          type="primary"
          overlay={
            <Menu
              activeKey={replyType}
              onClick={(e) => {
                setReplyType(e.key as Review.ReplyType);
              }}
            >
              <Menu.Item key="mainReply">
                {t('scene.reviewWorkspace.reply.action.replyToMainReview')}
              </Menu.Item>
              <Menu.Item key="followReply">
                {t('scene.reviewWorkspace.reply.action.replyToFollowUpReview')}
              </Menu.Item>
            </Menu>
          }
          onClick={() => {
            if (replyType === 'mainReply') {
              tiktokReply();
            }
            if (replyType === 'followReply') {
              tiktokReply(buyerFollowReview.id);
            }
          }}
          loading={loading}
        >
          {replyType === 'mainReply'
            ? t('scene.reviewWorkspace.reply.action.replyToMainReview')
            : t('scene.reviewWorkspace.reply.action.replyToFollowUpReview')}
        </Dropdown.Button>
      );
    } else if ((!sellerMainReply && detail) || sellerFollowReply) {
      return (
        <StatusButton type="primary" onClick={() => onSubmit()}>
          {t('scene.reviewWorkspace.reply.action.replyToMainReview')}
        </StatusButton>
      );
    } else if (sellerMainReply && !sellerFollowReply && buyerFollowReview?.id) {
      return (
        <StatusButton type="primary" onClick={() => onSubmit(buyerFollowReview.id)}>
          {t('scene.reviewWorkspace.reply.action.replyToFollowUpReview')}
        </StatusButton>
      );
    } else {
      return (
        <StatusButton type="primary" onClick={() => onSubmit()}>
          {t('scene.reviewWorkspace.reply.action.replyToMainReview')}
        </StatusButton>
      );
    }
  }

  return (
    <StatusButton type="primary" onClick={() => onSubmit()}>
      {t('scene.reviewWorkspace.reply.action.reply')}
    </StatusButton>
  );
};
